import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../history";
import { LocalStorageKey, PageRoute, UserRole } from "../../../models";
import { selectAdData, setAdData } from "../../../routes/AdForm/adForm.ducks";
import {
  checkEmptyArray,
  checkEmptyObject,
  localStorage
} from "../../../services";
import { selectCategories, selectModules } from "../../App/selectors";
import NextButton from "../../SelectModulePage/TitleWithModule/NextButton";
import styles from "./styles.scss";
import { mapCategoryToHr, mapModuleToHr } from "../../../routes/LanguageMapper";
import { Form, Input, Select } from "antd";
import { defaultSettings } from "../../SelectModulePage/TitleWithModule";
import { selectUserInfo } from "../../../routes/Auth/auth.ducks";

export interface IEditTitleProps {
  title: string;
  location: any;
  loading: boolean;
  settings: any;
  form: any
}

const EditTitle = (props: IEditTitleProps) => {
  const {
    title,
    location: { state },
    loading,
    settings: { formValidator },
    form,
  } = props;

  const [filteredCategories, setfilteredCategories] = useState([]);
  const [isValidating, setIsValidating] = useState(false);

  const dispatch = useDispatch();

  const modules = useSelector(selectModules);
  const categories = useSelector(selectCategories);
  const adData = useSelector(selectAdData);
  const userData = useSelector(selectUserInfo);
  const isSelectDisabled = !userData || (
    userData.role !== UserRole.admin &&
    userData.role !== UserRole.superAdmin
  );

  useEffect(() => {
    if (checkEmptyArray(categories) && checkEmptyObject(adData)) {
      setfilteredCategories(
        categories.filter(c => c.moduleName == adData.module)
      );

      form.setFieldsValue({
        title: adData.title,
        module: mapModuleToHr(adData.module),
        category: mapCategoryToHr(adData.category, adData.module)
      });
    }
  }, [adData, categories]);

  // Filter categories
  const filterCategories = useCallback(module => {
    module && setfilteredCategories(categories.filter(c => c.moduleRoute == module));
  }, [categories]);

  const handleSubmit = useCallback(e => {
    e.preventDefault();
    setIsValidating(true);

    form.validateFields( async (error, values) => {
      setIsValidating(false);

      if (!error) {
        const tempAdData = {
          ...adData,
          ...values
        };
        localStorage.setItem(LocalStorageKey.savedForm, tempAdData);
        await dispatch(setAdData(tempAdData));

        if (state && state.skipAsking) {
          history.push(`/${values.module}${PageRoute.postAd}/${values.category}`, {
            skipAsking: true
          });
        } else {
          history.push(`/${values.module}${PageRoute.editAd}/${adData.id}`);
        }
      }
    });
  }, [form, adData, localStorage, setAdData, state, history]);

  // Handle module change
  const onModuleChange = useCallback(module => {
    filterCategories(module);
    form.setFieldsValue({ category: null });
  }, [form, filterCategories]);

  return (
    <div className={styles.content}>
      {!title ? null : <div className={styles.title}>{title}</div>}
      <div className={styles.actions}>
        <Form layout="vertical">
          <p className={styles.subtitle}>{"Naslov oglasa"}</p>
          <Form.Item>
            {form.getFieldDecorator("title", {
              rules: formValidator.title
            })(<Input
                className={styles.input}
                suffix={`${form.getFieldValue("title") ? form.getFieldValue("title").length : 0} / 100`}
            />)}
          </Form.Item>

          <div className={styles.dropDown}>
            <p className={styles.disabled}>{"Odaberite kategoriju"}</p>
            <Form.Item>
              {form.getFieldDecorator("module", {
                rules: formValidator.module
              })(< Select onChange = { module => onModuleChange(module)}
                disabled={isSelectDisabled}
                className={isSelectDisabled ? styles.disabledSelect : ""}
              >
                {modules &&
                  modules.map(option => (
                    <Select.Option
                      key={option.id}
                      value={option.route}
                      // @ts-ignore
                      className={styles.option}
                    >
                      {option.displayName}
                    </Select.Option>
                  ))}
              </Select>)}
            </Form.Item>
          </div>

          <div className={styles.dropDown}>
            <p className={styles.disabled}>{"Odaberi potkategoriju"}</p>
            <Form.Item>
              {form.getFieldDecorator("category", {
                rules: formValidator.category
              })(<Select
                disabled={isSelectDisabled}
                className={isSelectDisabled ? styles.disabledSelect : ""}
              >
                  {filteredCategories &&
                    filteredCategories.map(option => (
                      <Select.Option
                        key={option.id}
                        value={option.route}
                        // @ts-ignore
                        className={styles.option}
                      >
                        {option.displayName}
                      </Select.Option>
                    ))}
                </Select>)}
            </Form.Item>
          </div>
        </Form>

      </div>
      <NextButton
        onClick={handleSubmit}
        isEnable={true}
        isLoading={isValidating}
      />
    </div>
  );
};

EditTitle.defaultProps = {
  loading: false,
  settings: defaultSettings,
};

export default Form.create()(EditTitle);



// WEBPACK FOOTER //
// ./src/containers/EditModulePage/EditTitle/index.tsx